import * as React from 'react';
import AvatarGroup, { AvatarProps } from '@atlaskit/avatar-group';
import { ViewerProfile } from '@atlassian/cssxp-types-socket';
import isEmpty from 'lodash/isEmpty';
// import analytics from '../../../../common/analytics';
// import {
//     AnalyticsUiAction,
//     AnalyticsUiSubject,
// } from '../../analytics/constants';

interface Props {
  viewers?: ViewerProfile[];
}

interface AvatarPropsWithEmail extends AvatarProps {
  email: string;
}

const CurrentPageViewers = ({ viewers = [] }: Props) => {
  const [avatarData, setAvatarData] = React.useState<AvatarPropsWithEmail[]>([]);

  // since viewers is an array-object, useEffect has a difficult time understanding equality
  const viewersStringified = JSON.stringify(viewers);

  React.useEffect(() => {
    const parsedViewers = JSON.parse(viewersStringified) as ViewerProfile[] | undefined;
    if (parsedViewers) {
      const transformedViewerData: AvatarPropsWithEmail[] = (parsedViewers ?? []).map((viewer, index) => ({
        key: `${index}-${viewer.email}`,
        name: viewer.displayName ?? viewer.email,
        enableTooltip: true,
        src: viewer.avatarUrl,
        email: viewer.email,
      }));
      setAvatarData(transformedViewerData);
    }
  }, [viewersStringified]);

  const onAvatarClickHandler = (_event: unknown, _analyticsEvent: unknown, index: number) => {
    // analytics.sendUIEvent({
    //     action: AnalyticsUiAction.CLICKED,
    //     actionSubject: AnalyticsUiSubject.BUTTON,
    //     actionSubjectId: 'openSlackMessageButton',
    // });

    const email = avatarData[index].email;
    window.open(`/api/1/redirects/slack/${email}`);
  };

  if (isEmpty(avatarData)) {
    return null;
  }

  return (
    <div className="avatar-group" style={{ marginRight: '16px' }}>
      <AvatarGroup data={avatarData} onAvatarClick={onAvatarClickHandler} />
    </div>
  );
};

export default CurrentPageViewers;
